/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { getAvatar } from "Models/User";
import cn from "classnames";
import { Heading, Stack, Text } from "components";
import Avatar from "components/Avatar";
import capitalize from "utils/capitalize";
import { useTranslation } from "react-i18next";

const CompanionSection = ({ companions, title, hasTitle = true }) => {
  const { t } = useTranslation();
  return (
    <Stack className="gap-y-5">
      {hasTitle && (
        <Heading
          as="h3"
          className={cn("-text--theme-colors-text-subtitle-brand")}
        >
          {title || t("companionSection.companionsLabel")}
        </Heading>
      )}
      <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-8">
        {companions.map((companion, i) => (
          <Companion key={i} companion={companion} />
        ))}
      </div>
    </Stack>
  );
};

const Companion = ({ companion }) => {
  const image = getAvatar(companion);
  return (
    <div className="flex items-center gap-x-3">
      <div className="w-[45px] h-[45px] shrink-0 border -border--theme-colors-border-neutral-inverse rounded-full">
        <Avatar
          className={"object-cover rounded-full"}
          src={image}
          alt="companion-img"
        />
      </div>
      <div className="flex flex-col w-36">
        <Text className="-text--theme-colors-text-body leading-6 whitespace-nowrap line-clamp-4 break-all">
          {capitalize(companion?.first_name || "")} {companion?.last_name}
        </Text>
        <Text className="-text--theme-colors-text-caption">
          {companion.relationship}
        </Text>
      </div>
    </div>
  );
};

export default CompanionSection;
